import CONSTANTS from '../../util/constants';

const initState = {
    isLoading: false,
    id: "",

    getLocationData: [],
    addLocationData: [],
    editLocationData: [],
    getLocationsByIdData: []
}

const LocationReducer = (state = initState, { type, payload }) => {

    switch (type) {

        case CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT.GET_LOCATION_API_SUCCESS:
            return {
                ...state,
                getLocationData: payload.value
            }

        case CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT.ADD_LOCATION_API_SUCCESS:
            return {
                ...state,
                addLocationData: payload.value
            }

        case CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT.EDIT_LOCATION_API_SUCCESS:

            return {
                ...state,
                editLocationData: payload.value
            }

        case CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT.GET_LOCATIONBYID_API_SUCCESS:

            return {
                ...state,
                getLocationsByIdData: payload.value
            }

        default:
            return state

    }
}

export default LocationReducer;
